export default __webpack_public_path__ + "static/media/okapi.896bd0d0.png";